import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * true cuando el usuario solo puede ver la mentoría (admin de la empresa cliente),
 * es decir, no es super admin ni mentor del proyecto. La escritura la bloquea RLS;
 * este flag solo oculta los controles.
 */
export function useMentorshipReadOnly(projectId: string | undefined) {
  const { user, roles } = useAuth();
  const isSuperAdmin = roles.includes('super_admin');
  const { data: isMember, isLoading } = useQuery({
    queryKey: ['mentorship-member', projectId, user?.id],
    enabled: !!projectId && !!user && !isSuperAdmin,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_mentorship_project_member', { _project_id: projectId! });
      if (error) throw error;
      return !!data;
    },
  });
  if (isSuperAdmin) return false;
  if (isLoading) return true;
  return !isMember;
}
